module.exports = __webpack_public_path__ + "static/media/lumbering16.7b405b5b.jpg";